import { List } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

const HorizontalList = styled(List)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    '& [class*="MuiListItem-root"]': {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        width: 'auto',
        '&[class*="MuiListItem-button"]': {
            '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'underline',
            },
        },
    },
    '& [class*="MuiListItem-root"]:first-child': {
        paddingLeft: 0,
    },
    '& [class*="MuiListItem-root"]:last-child': {
        paddingRight: 0,
    },
    '& [class*="MuiListItem-root"]:not(:last-child)': {
        borderRight: `1px solid currentcolor`,
    },
    '& [class*="MuiListItemText-root"]': {
        margin: 0,
    },
}));

export default HorizontalList;
